import { UseBaseQueryOptions, useQuery } from '@tanstack/react-query'
import { getThemePresets } from '../../services'
import { ThemePresetQueryKeys } from '@/modules/client-setting/keys'
import type { GetThemePresetsResponse } from '@/modules/client-setting/type'

export default function useQueryGetThemePresets(
	props?: UseBaseQueryOptions<GetThemePresetsResponse>,
) {
	return useQuery({
		queryKey: [ThemePresetQueryKeys.GetThemePresets],
		queryFn: () => getThemePresets(),
		...props,
	})
}
